import React,{useState,useEffect} from "react";
import Appbar from "../Appbar";
import {
    Alert,
    Badge,
    CircularProgress, Grid,
    IconButton,
    Paper,
    Table,
    TableBody, TableCell, tableCellClasses,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {Link} from "react-router-dom";
import {styled} from "@mui/material/styles";
import axios from "axios";
import ShowOrder from "./ShowOrder";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const OrderList = ()=>{
    const [orderList , setOrderList] = useState("");
    const [loading , setLoading] = useState(true);
    const [change , setChange] = useState(false);
    const [showOrder , setshowOrder] = useState(false);
    const [factorNumber , setFactorNumber] = useState("");
    useEffect(()=>{
        setLoading(true);
        axios.post("https://app.zhivay.com/api/get_orders.php")
            .then(respone => {
                setOrderList(respone.data);
                setLoading(false);
            })
            .catch(error =>{
                    console.log(error);
                    setLoading(false);
            });
        setChange(false);
        setshowOrder(false);
    },[change]);
    const hendel_order_click = (fnumber)=>{
        setFactorNumber(fnumber);
        setshowOrder(true);
    }
    return(
        <div>

            <Appbar/>
            <p>


            </p>
            <Grid
                container
                direction="row"
                justifyContent="center"
                alignItems="center">
            {!loading ?
                <TableContainer component={Paper} sx={{margin:2}}>
                    <Table sx={{ minWidth: 250,maxHeight:'80%',overflowY:'auto',}} className='tbl-pishfactor'>
                        <TableHead>
                            <TableRow>
                                <StyledTableCell align="left">وضعیت</StyledTableCell>
                                <StyledTableCell align="right">آدرس</StyledTableCell>
                                <StyledTableCell align="right">نام مشتری</StyledTableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {orderList.map(order => (
                                <StyledTableRow
                                    component={Link} to="/orders"
                                    onClick={()=>hendel_order_click(order.order_factornumber)}
                                    key={order.id}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                    <StyledTableCell align="left">
                                        {order.status === "0" ?
                                            <Alert
                                            variant="filled"
                                            severity="error"
                                            sx={{width: "21px"}}
                                            />
                                            :
                                            <Alert
                                            variant="filled"
                                            severity="success"
                                            sx={{width: "21px"}}
                                            />
                                        }
                                    </StyledTableCell>
                                    <StyledTableCell component="th" scope="row" align="right">{order.customer_address}</StyledTableCell>
                                    <StyledTableCell align="right">
                                        {order.customer_name}
                                    </StyledTableCell>
                                </StyledTableRow >
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                : <CircularProgress sx={{margin:2}} /> }
            </Grid>
            {showOrder ? <ShowOrder setChange={setChange} showorder={setshowOrder} fnumber={factorNumber}/> : ''}
        </div>

    )
}
export default OrderList;
